import { createContext } from 'react';

export const ScrollContext = createContext();

export const scrollToAnchor = anchor => {
  const scrollTarget = document.getElementById(anchor);
  scrollTarget?.scrollIntoView({ behavior: 'smooth' });
};
